import {createAction} from "redux-act";

export const openTutorial = createAction();
export const closeTutorial = createAction();
export const setActiveStep = createAction<number>();
export const setIsOpenMobileNavigation = createAction<boolean>();
